// extracted by mini-css-extract-plugin
export default {"Projects":"Projects_Projects__EFmAR"};